import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import 'url-search-params-polyfill'

export default class NavigationService {
  constructor () {
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.contextToken = this.authService.getToken()
    this.uuid = this.authService.getUUID()
  }

  getParams () {
    const params = new URLSearchParams(window.location.search)
    return params
  }
  getUuid () {
    const params = this.getParams()
    const uuid = params.get('uuid') ? params.get('uuid') : null
    return uuid
  }

  getLoginUrl () {
    // return this.authService.isAdmin() ? '/admin' : '/'
    if (this.authService.isAdmin() || window.location.pathname.indexOf('/admin') > -1) {
      return Config.adminColdFusionUrl + '?pg=Login'
    } else {
      return Config.coldFusionUrl + '?pg=Login'
    }
  }

  //= ======** Navigations **===========

  signoutIfNotLoggedIn () {
    if (!this.authService.isLoggedIn() && !(window.location.pathname === '/' || window.location.pathname === '/admin' ||
        window.location.pathname === '/manageAccount/forgotpassword' || window.location.pathname === '/validateAccount' ||
        window.location.pathname.split('&')[0] === '/manageAccount/resetpassword' || window.location.pathname === '/logout'
        || window.location.pathname === '/admin/logout' || window.location.pathname.split('&')[0] === '/leaderBoardInvite')
    ) {  
      
        window.location.href = '/logout';
    }
  }

  // This method is used to generate the url and send it back to the caller.
  getUrl (menu) {
    return this.getMenu(menu)
  }
  // this method has been used to set the navigation to the prepared url.
  toUrl (menu) {
    window.location.href = this.getMenu(menu)
  }

  // This method to get the sub menu selected for the user or an account.
  getSubMenuUrl (menu) {
    const uuid = this.getUuid()
    return this.getMenu(menu, uuid)
  }
  // Get the selected menu item for highlighting in the screen.
  getSelectedMenu () {
    let url = window.location.href
    let page = url.substr(url.lastIndexOf('/') + 1).split(/[?#]/)[0]
    let selectedMenu
    if (this.authService.isAdmin()) {
      switch (page) {
        case 'accounts':
        case 'account':
          selectedMenu = `accounts`
          break
        case 'viewDetail':
        case 'viewdetails':
          if (!this.getUuid()) {
            selectedMenu = `systems`
          } else {
            selectedMenu = `users`
          }
          break
        default:
          selectedMenu = this.authService.getSelectedMenu()
      }
    } else {
      switch (page) {
        case 'users':
        case 'stores':
        case 'roles':
        case 'addRoles':
          selectedMenu = `stores`
          break
        case 'summaryreport':
        case 'rawcardatareport':
          selectedMenu = `reports`
          break
        case 'storeRanking':
          selectedMenu = `dashboard`
          break
        case 'viewDetail':
        case 'viewdetails':
          selectedMenu = `stores`
          break
        case 'leaderBoards':
          selectedMenu = `leaderBoards`
          break
        case 'leaderboardGroup':
          selectedMenu = `leaderBoards`
          break
        default:
          selectedMenu = page
      }
    }
    return selectedMenu
  }

  // This method used to set the selected menu item for the future reference
  // to identify where the navigation has initiated.
  setSelectedMenu () {
    if (this.authService.isLoggedIn()) {
      if (!this.getUuid()) {
        if (!this.authService.isAdmin()) {
          this.authService.clearUUID()
        }
        let url = window.location.href
        var page = url.substr(url.lastIndexOf('/') + 1).split(/[?#]/)[0]
        this.authService.setSelectedMenu(page)
      }
    }
  }

  // This method used to generate the url according to the configuration.
  getMenu (page, uuid, subVersion = '3.x') {
    let isAdmin = this.authService.isAdmin() || window.location.pathname.indexOf('/admin') > -1
    let cfUrl = (isAdmin) ? Config.adminColdFusionUrl : Config.coldFusionUrl
    let url = ''
    let token = ''
    if (this.authService.isMasquerade()) {
      let user = this.authService.getProfile()
      let userName = user.name ? user.name : user.User_FirstName + ' ' + user.User_LastName
      token = 'atoken=' + this.authService.getIdToken() + '&memail=' + encodeURIComponent(user.User_EmailAddress) + '&un=' + userName
    } else { token = 'token=' + this.authService.getToken() }

    let isFromCF = Config.coldFusionPages ? Config.coldFusionPages.indexOf(page) > -1 : false
    switch (page) {
      case 'systems':
        url = isFromCF ? cfUrl + '?pg=SettingsDevices&path=Main&' + token : '/systems'
        break
      case 'stores':
        if (uuid) { url = isFromCF ? cfUrl + '?pg=SettingsStores&path=Users&uuid=' + uuid + '&' + token : '/settings/stores?uuid=' + uuid } else { url = isFromCF ? cfUrl + '?pg=SettingsStores&path=Main&' + token : (isAdmin ? '/admin/settings/stores' : '/settings/stores') }
        break
      case 'users':
        if (uuid) {
          url = isFromCF ? cfUrl + '?pg=SettingsUsers&path=Users&uuid=' + uuid + '&' + token : '/settings/users?uuid=' + uuid
        } else {
          url = isFromCF ? cfUrl + '?pg=SettingsUsers&path=Main&' + token : (isAdmin ? '/admin/settings/users' : '/settings/users')
        }
        break
      case 'roles':
        if (uuid) { url = isFromCF ? cfUrl + '?pg=SettingsRoles&path=Users&uuid=' + uuid + '&' + token : '/settings/roles?uuid=' + uuid } else { url = isFromCF ? cfUrl + '?pg=SettingsRoles&' + token : '/settings/roles' }
        break
      case 'dashboard':
        if (uuid) { url = isFromCF ? cfUrl + '?pg=Dashboard&path=Users&uuid=' + uuid + '&' + token : '/dashboard?uuid=' + uuid } else { url = isFromCF ? cfUrl + '?pg=Dashboards&' + token : '/dashboard' }
        break
      case 'reports':
        if (uuid) { url = isFromCF ? cfUrl + '?pg=Reports&uuid=' + uuid + '&' + token : '/reports?uuid=' + uuid } else { url = isFromCF ? cfUrl + '?pg=Reports&' + token : '/reports' }
        break
      case 'devicehistory':
        url = isFromCF ? cfUrl + '?pg=SettingsZoomHistory&uuid=' + uuid + '&path=Accounts&' + token : '/admin/settings/deviceHistory?uuid=' + uuid
        break
      case 'accounts':
      case 'myAccount':
        url = isFromCF ? cfUrl + (isAdmin ? '?pg=SettingsAccounts&' : '?pg=SettingsAccount&') + token : (isAdmin ? '/admin/accounts' : '/myAccount')
        break
      case 'distributors':
        url = isFromCF ? cfUrl + '?pg=SettingsDistributors&' + token : '/admin/distributors'
        break
      case 'displaysettings':
        url = isFromCF ? cfUrl + '?pg=Settings&' + token : '/displaysettings'
        break
      case 'leaderBoards':
        url = isFromCF ? cfUrl + '?pg=Leaderboard&st=Edit&' + token : '/leaderBoards'
        break;
      case 'leaderboard':
        url = isFromCF ? cfUrl + '?pg=Leaderboard&st=Edit&' + token : '/leaderboard'
        break
      case 'leaderboardgroup':
        url = isFromCF ? cfUrl + '?pg=SettingsGroups&' + token : '/settings/stores/leaderBoardGroups'
        break
      case 'help':
        url = isFromCF ? cfUrl + '?pg=Help&' + token : '/help'
        break
      case 'welcome':
        url = isFromCF ? cfUrl + '?pg=SettingsStores&path=Main&' + token : '/welcome'
        break
      case 'connect':
        let adminParam = (isAdmin)? '&a=true':'&a=false'
        url = isFromCF ? cfUrl.replace('https', 'http') + (isAdmin ? '?pg=SettingsStores&st=connect&duid=' : '?pg=SettingsDevices&st=connect&duid=') + uuid + '&' + token : window.location.origin.replace('https', 'http') + '/connect?duid=' + uuid + '&' + token + adminParam
        break
      case 'reboot':
        url = isFromCF ? cfUrl + '?pg=SettingsDevices&st=reboot&duid=' + uuid + '&' + token : '/reboot?duid=' + uuid
        break
      case 'reconnect':
        url = isFromCF ? cfUrl + '?pg=SettingsDevices&st=reconnect&duid=' + uuid + '&' + token : '/reconnect?duid=' + uuid
        break
      case 'upgrade':
        url = isFromCF ? cfUrl + `?pg=SettingsDevices&st=upgrade&duid=${uuid}&vz=${subVersion}&${token}` : `/upgrade?duid=${uuid}&vz=${subVersion}`
        break
      default:
        url = ''
    }
    return url
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/NavigationServices.js